import { Component, EventEmitter, Output, output } from '@angular/core';
import { MenusComponent } from '../menus/menus.component';
import { LogoutComponent } from '../logout/logout.component';
import { Router, RouterLink } from '@angular/router';

@Component({
  selector: 'app-login-header',
  standalone: true,
  imports: [MenusComponent,LogoutComponent,RouterLink],
  templateUrl: './login-header.component.html',
  styleUrl: './login-header.component.scss'
})
export class LoginHeaderComponent {


  @Output() selectedMenuItem = new EventEmitter<string>();
  onNavigation(selectedmenu: string) {
    this.selectedMenuItem.emit(selectedmenu);
    console.log('Selected Menu header:', selectedmenu);
  }
}
